import { render, staticRenderFns } from "./requirements.vue?vue&type=template&id=0655a804&scoped=true&"
import script from "./requirements.vue?vue&type=script&lang=js&"
export * from "./requirements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0655a804",
  null
  
)

export default component.exports